import { TOKEN_DATA_TYPE } from "enum/enums";
import UseApiService from "./apiService";

class OrganizationService {
	generateNewApiKey({ id, apiKeyName,apiKeyType }: { id: string; apiKeyName: string,apiKeyType:string }) {
		const body = {
			url: `/tenants/${id}/apikeys`,
			data: {
				apiKeyName,
				apiKeyType
			},
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService().post(body);
	}

	getListApiKey(id: string) {
		console.log(id, "id");

		const body = {
			url: `/tenants/${id}/apikeys`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService().get(body);
	}

	getTenantInfo(id: string) {
		const body = {
			url: `/tenants/${id}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService().get(body);
	}

	deleteApiKey({ id, apiKeyHash }: { id: string; apiKeyHash: string }) {
		const body = {
			url: `/tenants/${id}/apikeys`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
			data: {
				apiKeyHash,
			},
		};
		return UseApiService().delete(body);
	}

	getRegistered({ orgName, tenantAdminEmail, tenantAdminName }: { orgName: string; tenantAdminEmail: string; tenantAdminName: string }) {
		const body = {
			url: `/tenants/register`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
			data: {
				orgName,
				tenantAdminEmail,
				tenantAdminName,
			},
		};
		return UseApiService().post(body);
	}

	getTenantList() {
		const body = {
			url: `/tenants`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		return UseApiService().get(body);
	}

	getUsageDetails({ tenantId, startDate, endDate, pageToken = "" }: { tenantId: string; startDate: string; endDate: string; pageToken?: string }) {
		const body = {
			url: `/tenants/${tenantId}/usage?startDate=${startDate}&endDate=${endDate}`,
			headerToken: TOKEN_DATA_TYPE.ACCESS,
		};
		if (pageToken) {
			body.url += `&pageToken=${pageToken}`;
		}
		return UseApiService().get(body);
	}
}
const organization = new OrganizationService();
export default organization;
